import { GeoDsMeta } from "@geods/base";

export class MeasuringDevice extends GeoDsMeta {
    Designation: string;

    constructor(data) {
        super();
        Object.assign(this, data);
    }
}